export default {
  data() {
    return {
      workStartPaginateDataList: [],
      workStartDetail: null,
      takeoffLandingList: [],
      groundingList: [],
      helicopterReplacementList: [],
      refuelList: [],
    };
  },
  methods: {
    getPhoneActivityWorkStartList: function (params) {
      this.load.val = true;
      this.$store
        .dispatch('getPhoneActivityWorkStartListDispatch', params)
        .then(() => {
          if (this.$store.state.airAmbulanceModule.successFlag) {
            const data = this.$store.state.airAmbulanceModule.workStartPaginateData;

            this.workStartPaginateDataList = this.transformWorkStartList([...data?.items]);
            this.setPagination(data);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.airAmbulanceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getPhoneActivityWorkStartList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.airAmbulanceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getPhoneActivityWorkStartList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getPhoneActivityWorkStartDetail: function (phoneActivityId) {
      const params = { phoneActivityId };
      this.load.val = true;
      this.$store
        .dispatch('getPhoneActivityWorkStartDetailDispatch', params)
        .then(() => {
          if (this.$store.state.airAmbulanceModule.successFlag) {
            const data = this.$store.state.airAmbulanceModule.workStartDetail;
            this.workStartDetail = data;
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.airAmbulanceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getPhoneActivityWorkStartList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.airAmbulanceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getPhoneActivityWorkStartList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getTakeoffAndLandingList: function (params) {
      this.load.val = true;
      this.$store
        .dispatch('getTakeoffLandingListDispatch', params)
        .then(() => {
          if (this.$store.state.airAmbulanceModule.successFlag) {
            const data = this.$store.state.airAmbulanceModule.takeoffLandingData;
            this.setPagination(data);
            this.takeoffLandingList = this.transformTakeoffAndLandingList(data?.items);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.airAmbulanceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getTakeoffLandingList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.airAmbulanceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getTakeoffLandingList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getHelicopterReplacementList: function (params) {
      this.load.val = true;
      this.$store
        .dispatch('getHelicopterReplacementDispatch', params)
        .then(() => {
          if (this.$store.state.airAmbulanceModule.successFlag) {
            const data = this.$store.state.airAmbulanceModule.helicopterReplacementData;
            this.setPagination(data);
            this.helicopterReplacementList = this.transformReplacementHelicopterList(data?.items);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.airAmbulanceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getHelicopterReplacementList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.airAmbulanceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getHelicopterReplacementList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getGroundingList: function (params) {
      this.load.val = true;
      this.$store
        .dispatch('getGroundingListDispatch', params)
        .then(() => {
          if (this.$store.state.airAmbulanceModule.successFlag) {
            const data = this.$store.state.airAmbulanceModule.groundingData;
            this.setPagination(data);
            this.groundingList = this.transformGroundingList(data?.items);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.airAmbulanceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getGroundingList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.airAmbulanceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getGroundingList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getRefuelList: function (params) {
      this.load.val = true;
      this.$store
        .dispatch('getRefuelDataDispatch', params)
        .then(() => {
          if (this.$store.state.airAmbulanceModule.successFlag) {
            const data = this.$store.state.airAmbulanceModule.refuelData;
            this.setPagination(data);
            this.refuelList = this.transformRefuelList(data?.items);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.airAmbulanceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getRefuelList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.airAmbulanceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getRefuelList(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
  },
};
